<template>
	<pre v-html="$t('terms.legal_indication8')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication8',
};
</script>

<style scoped></style>
